import React from "react";

import l from "components/util/l";
import BlockView from "components/util/changes/ChangeView.sub.Block.view";
import FieldsView from "components/util/changes/ChangeView.sub.Fields.view";

const STATUS_STYLES = {
  added: "badge-success",
  modified: "badge-warning",
  removed: "badge-danger",
  unchanged: "badge-light",
};

const STATUS_LABELS = {
  added: l("Se crea%EN028"),
  modified: l("Se sobrescribe%EN029"),
  removed: l("Se elimina%EN030"),
  unchanged: l("Sin cambios%PA810"),
};

const EntityView = ({
  entity,
  collapsedKeys,
  expandedItemKeys,
  onToggleCollapse,
  onToggleItem,
}) => {

  const isCollapsed = collapsedKeys.includes(entity.key);
  const hasDetail = entity.fields.length > 0 || entity.blocks.length > 0 || entity.children.length > 0;

  return (
    <div className="change-view-entity">

      <div className={`change-view-entity-head ${isCollapsed || !hasDetail ? "is-collapsed" : ""}`}
        onClick={() => hasDetail && onToggleCollapse(entity.key)}>

        <span className="change-view-caret">
          {hasDetail && <i className={`fas fa-chevron-${isCollapsed ? "right" : "down"}`}></i>}
        </span>

        <span className="change-view-entity-name">{entity.label}</span>
        {entity.sublabel && <span className="change-view-entity-sub">{entity.sublabel}</span>}

        <span className="change-view-entity-badge">
          <span className={`badge ${STATUS_STYLES[entity.status]}`}>{STATUS_LABELS[entity.status]}</span>
        </span>
      </div>

      {
        !isCollapsed &&
        <>
          <FieldsView fields={entity.fields} />

          {entity.blocks.map((block) => (
            <BlockView key={block.key} block={block} entityKey={entity.key}
              expandedItemKeys={expandedItemKeys} onToggleItem={onToggleItem} />
          ))}

          {
            entity.children.length > 0 &&
            <div className="change-view-children">
              {entity.children.map((child) => (
                <EntityView key={child.key} entity={child}
                  collapsedKeys={collapsedKeys} expandedItemKeys={expandedItemKeys}
                  onToggleCollapse={onToggleCollapse} onToggleItem={onToggleItem} />
              ))}
            </div>
          }
        </>
      }

    </div>
  );

}

export default EntityView;
